var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 45,
    x2: 45,
    y1: 84.788,
    y2: 4.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2161ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b7fe2"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 0,
    transform: "matrix(2.8 0 0 2.8 1.964 1.964)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "url(#a)",
    opacity: 1,
    "data-original": "url(#a)",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M49.798 55.043c0-1.522-.376-2.716-1.127-3.584-.752-.867-2.072-1.686-3.96-2.456-1.889-.77-3.632-1.551-5.231-2.341s-2.977-1.706-4.133-2.746-2.043-2.245-2.659-3.614c-.617-1.367-.925-3.024-.925-4.971 0-3.256 1.098-5.939 3.295-8.049 2.196-2.11 5.125-3.338 8.786-3.685V17.5h4.596v6.214c3.525.521 6.295 1.971 8.309 4.35 2.013 2.38 3.02 5.4 3.02 9.06H50c0-2.003-.386-3.545-1.157-4.624-.77-1.079-1.869-1.618-3.294-1.618-1.272 0-2.259.4-2.963 1.199-.703.8-1.055 1.903-1.055 3.309 0 1.426.405 2.558 1.214 3.396s2.11 1.638 3.902 2.399 3.483 1.551 5.072 2.37 2.962 1.748 4.119 2.789c1.156 1.04 2.061 2.255 2.716 3.642s.983 3.054.983 4.999c0 3.295-1.045 5.983-3.136 8.064s-4.937 3.295-8.541 3.641v5.81h-4.595v-5.838c-4.201-.444-7.423-1.883-9.668-4.321-2.245-2.437-3.367-5.65-3.367-9.638h9.74c0 2.197.486 3.869 1.459 5.014.973 1.147 2.356 1.72 4.148 1.72 1.31 0 2.341-.39 3.093-1.171.751-.781 1.128-1.854 1.128-3.223z",
    opacity: 1,
    "data-original": "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdLogo);
export default __webpack_public_path__ + "static/media/usd-logo.0549f55722614f69f39c9fc5aec9973f.svg";
export { ForwardRef as ReactComponent };